import { configure } from 'mobx';

// Side-effect only module — must be the first import in main.jsx so this runs
// before any store module (which create observables at module scope) is evaluated.
configure({
  // Keep app reactions independent of other MobX registries in the page.
  isolateGlobalState: true,
  // enforceActions: 'never',
  useProxies: 'never',
  enforceActions: 'always',
  computedRequiresReaction: true,
  reactionScheduler: f => setTimeout(f)
});
